import PropTypes from "prop-types";
const Input = (props) => {
  const { type, classes, inputClasses, value, handler, required, placeHolder } = props;

  return (
    <div className={classes}>
      <input
        placeholder={placeHolder}
        type={type || 'text'} 
        className={inputClasses}
        value={value}
        onChange={(e) => handler(e.target.value)}
        required={required}
      />
    </div>
  );
};

Input.propTypes = {
  type: PropTypes.string,
  classes: PropTypes.string,
  inputClasses: PropTypes.string,
  value: PropTypes.string,
  handler: PropTypes.func,
  required: PropTypes.bool,
  placeHolder: PropTypes.string,
};

Input.defaultProps = {
  required: false,
  value: '',
  placeHolder: 'Type Here'
}

export default Input;
